<script>
import devData from './dev-data/foam.stats.json'
import { sumBy, chain, map, capitalize } from 'lodash'
import moment from 'moment'
import toCurrency from '@/helpers/currency'

function humanize (str) {
  return str
    .trim()
    .split(/\s+/)
    .map(function (str) {
      return str.replace(/_/g, ' ').replace(/\s+/, ' ').trim()
    })
    .join(' ')
    .toLowerCase()
    .replace(/^./, function (m) {
      return capitalize(m.toUpperCase())
    })
}

export default {
  name: 'foam-type-stats',
  props: {
    data_field: { type: String, default: 'quantity' },
    title: { type: String }
  },
  data () {
    return {
      quantity: 0,
      trend: 0,
      series: []
    }
  },
  computed: {
    chartOptions () {
      var isCurrency = this.data_field === 'revenue'
      return {
        chart: {
          type: 'pie',
          height: 300,
          zoom: {
            enabled: true,
            type: 'x',
            autoScaleYaxis: false,
            zoomedArea: {
              fill: {
                color: '#90CAF9',
                opacity: 0.4
              },
              stroke: {
                color: '#0D47A1',
                opacity: 0.4,
                width: 1
              }
            }
          }
        },
        title: {
          text: this.title
        },
        dataLabels: {
          formatter (val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex]
            return [val.toFixed(1) + '%']
          }
        },
        legend: {
          /*
           * @param {string} seriesName - The name of the series corresponding to the legend
           * @param {object} opts - Contains additional information as below
           * opts: {
           *   seriesIndex
           *   w: {
           *     config,
           *     globals
           *   },
           * }
           */
          formatter: function (seriesName, opts) {
            if (isCurrency)
              return [
                seriesName,
                ' - ',
                toCurrency(opts.w.globals.series[opts.seriesIndex])
              ]
            else
              return [
                seriesName,
                ' - ',
                opts.w.globals.series[opts.seriesIndex]
              ]
          }
        },
        tooltip: {
          y: {
            formatter: isCurrency ? toCurrency : null,
            title: {
              formatter: seriesName => seriesName
            }
          }
        }
      }
    }
  },
  mounted () {
    this.onRefresh()
  },
  methods: {
    async onRefresh () {
      var result = []
      if (process.env.NODE_ENV !== 'production') {
        result = devData
      } else {
        console.log('prod')
      }

      var grouped = chain(result)
        .groupBy(x => x.tags)
        .map((data, tags) => ({
          tags,
          data: chain(data)
            .groupBy(y => moment(y.start_date).startOf('year'))
            .map((d, start_date) => ({
              quantity: sumBy(d, this.data_field),
              period: moment(start_date).format('YYYY')
            }))
            .value()
        }))
        .value()

      var data = chain(grouped)
        .flatMap('data')
        .groupBy('period')
        .map((item, key) => ({
          name: key,
          group: key,
          data: map(item, 'quantity')
        }))
        .value()

      var categories = chain(result)
        .groupBy(x => x.tags)
        .map((data, tags) => humanize(tags))
        .value()

      this.series = data
      this.series = chain(data).flatMap('data').value()

      this.$refs['yyy'].updateOptions({
        labels: categories
      })
    }
  }
}
</script>
<template>
  <b-card no-body
    ><b-card-body>
      <apexchart
        ref="yyy"
        width="100%"
        height="300"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </b-card-body>
  </b-card>
</template>
